import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getStaffingTargets() {
    return axiosIns.get('/waiter/staffing_targets')
  },

  createStaffingTarget(staffingTarget) {
    const formData = serialize(snakecaseKeys({ staffingTarget }))

    return axiosIns.post('/waiter/staffing_targets', formData)
  },

  updateStaffingTarget(staffingTarget) {
    const formData = serialize(snakecaseKeys({ staffingTarget }))

    return axiosIns.patch(`/waiter/staffing_targets/${staffingTarget.id}`, formData)
  },

  deleteStaffingTarget(id) {
    return axiosIns.delete(`/waiter/staffing_targets/${id}`)
  },
}
